// Custom JS using theme's default jQuery

jQuery(function($) {
  // Add action to the yellow box learn more link
  $('.teletails-video a, .virtual-vet .overlay-text a, .shopify-section-group-header-group a[title="Learn More"').attr('data-video', 'video1')

  // Add read-more to 24x7 virtual vet post
  const targetText = "Unlimited 24x7 veterinary telehealth";

  $('.featured-blog__article').each(function() {
    const $article = $(this);
    const $title = $article.find('.article__title');

    if ($title.text().includes(targetText)) {
      const $standardLink = $article.find('.standard-link');
      if ($standardLink.length) {
        $standardLink.attr('data-video', 'video1');
        $article.find('.standard-link').text('Learn More');
        $article.find('.article__read-more').show();
      }
    }
  });
  
  // Video popup
  const $videoThumbnails = $('[data-video]');
  const $modalOverlay = $('#modal-overlay');
  const $closeButton = $modalOverlay.find('.close-button');

  $videoThumbnails.each(function () {
    $(this).attr('href', '#');
    $(this).on('click', function (e) {
      e.preventDefault();
      const videoId = $(this).attr('data-video');
      openModal(videoId);
    });
  });

  $closeButton.on('click', closeModal);

  $modalOverlay.on('click', function (event) {
    if ($(event.target).is($modalOverlay)) {
      closeModal();
    }
  });

  $(document).on('keydown', function (event) {
    if (event.key === 'Escape') {
      closeModal();
    }
  });

  function openModal(videoId) {
    const $videoContainer = $('#' + videoId);
    if ($videoContainer.length) {
      $modalOverlay.css('display', 'flex');
      $videoContainer.css('display', 'block');
      const video = $videoContainer.find('video')[0];
      if (video) {
          video.play();
      }
    }
  }

  function closeModal() {
    $modalOverlay.css('display', 'none');
    $('.video-container').css('display', 'none');
    $('.self-video video').each(function() {
        this.pause();
    });
  }

  if(window.innerWidth < 767) {
    $('.video-columns .image-column').slick({
      dots: true,
      slidesToShow: 1,
      speed: 300
    })
  }

  // Change add-to-cart btn text
  $('.btn[data-add-to-cart] span').text('Add to bag')

  // Recharge subscriptions
  $(window).on('load', function() {
    $('.onetime-radio .rc-radio__label').html(function(_, html) {
      return html.replace(/(\$[\d.]+)/, '<span class="rc-radio__price">$1</span>');
    });
    $('.rc-radio__subscription').html('Membership Discount Plan <br><span class="rc-radio__subscription--small"><span  style="display: block; margin-bottom:2px;">*Plus $5.99 per month Membership Fee</span>(Member Benefits include Free Shipping, Unlimited 24x7 Vet Telehealth, and Lost Pet Finder Service)</span>');
    $(`
      <div class="reading-width text-center">
        <h2 class="giant-title  rich-text-section__title">Manage Your Subscription</h2>
        <div class="rte large-text">
          <p>If you would like to make any changes to your subscription please login below.</p>
        </div>
      </div>
    `).insertBefore('.rc-login--body');
    setTimeout(function() {
      $('.rc-widget, .row.ajax-product-form, .product-details__benefits, .product-details__terms')
        .css('visibility', 'visible') // Make it visible
        .hide() // Immediately hide it (but it's now taking up space)
        .fadeTo(500, 1); // Fade it in over 0.5 seconds
    }, 250);
  });
});